module.exports = __webpack_public_path__ + "static/media/play_previous.3ff1eb8b.svg";